import React from 'react'
import SidebarLogo from './SidebarLogo'
import SidebarMenu from './SidebarMenu'
import SidebarMenuDown from './SidebarMenuDown'

const Sidebar = () => {
  return (
    <div className='sidebar'>
		<SidebarLogo />
		<div className='sidebar__menus'>
			<SidebarMenu />
			<SidebarMenuDown />
		</div>
    </div>
  )
}

export default Sidebar